<rl-dialog-window (onSave)="save()" [title]="'main.recommendedFeatures'" [buttonsVisibility]="{ onSave: canEdit, onCancel: canEdit, onClose: !canEdit }">
  <rl-please-wait class="document-loader" [hidden]="!busy" [disable]="true"></rl-please-wait>
  <div class="modal-section no-padding-top notification-content">
    <p *rlPrivileges="editPrivileges" class="ContentSummary">{{ 'features.management.edit.dialogSubTitle' | translate }}</p>
    <p *rlNoPrivileges="editPrivileges" class="ContentSummary">{{ 'features.management.view.dialogSubTitle' | translate }}</p>
    <ul class="media-list justify-content flex-wrap">
      <li class="flex-half low-res-break padding-right feature-item" *ngFor="let f of features | contains : recommendedFeatures : 'code'">
        <ng-container *ngTemplateOutlet="featureConfigTemplate; context: { f: f }"></ng-container>
      </li>
    </ul>
    <rl-toggle-content [title]="'features.management.showMore'">
      <ul class="media-list justify-content flex-wrap">
        <li class="flex-half low-res-break padding-right feature-item" *ngFor="let f of features | notContains : recommendedFeatures : 'code'">
          <ng-container *ngTemplateOutlet="featureConfigTemplate; context: { f: f }"></ng-container>
        </li>
      </ul>
    </rl-toggle-content>
  </div>
</rl-dialog-window>
<ng-template #featureConfigTemplate let-f="f">
  <rl-feature [feature]="f"></rl-feature>
  <rl-toggle-button [id]="'TOGGLE_' + f.code" *rlPrivileges="editPrivileges" [active]="f.active" (onChange)="toggleFeature(f.code, $event)" [stateLabels]="{ on: 'features.management.toggle', off: 'features.management.toggle' }"></rl-toggle-button>
</ng-template>
